// extracted by mini-css-extract-plugin
export default {"container":"xda-z"};